export const buildSoundCloudUrl = (url) =>
  `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`;

export const getYouTubeId = (url) =>
  url?.match(/(?:youtube\.com\/(?:watch\?v=|live\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/)?.[1] ?? null;

export const fetchYouTubeTitle = (url) =>
  fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`)
    .then((r) => r.json())
    .then((data) => data.title);
